import axios from "lib/axios";

const guessNumber = async (guess) => {
  const { data } = await axios.post(`/game/gtn/check`, { guess: guess });
  return data;
};

const historyGuessNumber = async (guess) => {
  const { data } = await axios.get(`/game/gtn/state`);
  return data;
};

export { guessNumber, historyGuessNumber };
